import React, { FC, ReactNode } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import cn from 'classnames';
import css from './styles.module.scss';

// Объект цветов
export const INFO_BLOCK_COLORS = {
  BLUE: 'BLUE',
  YELLOW: 'YELLOW',
  GREEN: 'GREEN',
  WHITE: 'WHITE',
  RED: 'RED',
} as const;

// Тип цвета
export type TInfoBlockColor = keyof typeof INFO_BLOCK_COLORS;

interface IInfoBlockProps {
  color?: TInfoBlockColor;
  text: string | ReactNode;
  button?: ReactNode;
  customIcon?: ReactNode;
  alignItems?: 'top' | 'center';
  className?: string;
}

const InfoBlock: FC<IInfoBlockProps> = ({
  color = 'BLUE',
  text,
  button,
  customIcon,
  alignItems = 'center',
  className,
}) => (
  <div
    className={cn(css.info, 'InfoBlock', className, {
      _isBlue: color === 'BLUE',
      _isYellow: color === 'YELLOW',
      _isWhite: color === 'WHITE',
      _isGreen: color === 'GREEN',
      _isRed: color === 'RED',
      _isTopAlign: alignItems === 'top',
    })}
  >
    {customIcon || <FiAlertCircle size={20} />}
    <div
      className={cn(css.info_text, 'InfoBlock_text', {
        _isAddBtn: !!button,
      })}
    >
      <span>{text}</span>
      {button}
    </div>
  </div>
);

export default InfoBlock;
